export enum RequestState {
	IDLE,
	PENDING,
	SUCCESS,
	ERROR,
}

export enum RoundStatus {
	Scheduled = "scheduled",
	Playing = "playing",
	Complete = "complete",
}

export enum Language {
	EN = "en",
	Fr = "fr",
}

export enum SeasonFilter {
	PreSeason = "pre",
	RegularSeason = "reg",
	PostSeason = "post",
}

export enum MatchStatusEnum {
	COMPLETE = "complete",
	FIRST_QUARTER = "first_quarter",
	SECOND_QUARTER = "second_quarter",
	HALF_TIME = "half_time",
	PRE_MATCH = "pre_match",
	THIRD_QUARTER = "third_quarter",
	FOURTH_QUARTER = "fourth_quarter",
	OVERTIME = "overtime",
	SCHEDULED = "scheduled",
	CANCELED = "canceled",
}

export enum RoundType {
	PRE = "PRE",
	REG = "REG",
	POST = "POST",
}

export enum PossessionType {
	HOME = "Home",
	AWAY = "Away",
	NONE = "None",
}

export enum Locale {
	EN = "en",
	FR = "fr",
}

export enum ChangeOddsType {
	UP = "up",
	DOWN = "down",
	None = "none",
}
